<mat-expansion-panel class="content-group" (opened)="groupOpened()" (closed)="groupClosed()">
  <mat-expansion-panel-header class="primary-background-expansion-panel content-group__header" [collapsedHeight]="'90px'" [expandedHeight]="'90px'">
    <div class="content-group__header-content">
      <div class="d-flex align-items-center justify-content-center">
        <h3 class="content-group__title">{{ group?.name }}</h3>
      </div>
      <div class="content-group__info">
        @if (group.isCompleted && (group.lessonsCount || group.quizzesCount)) {
          <div class="content-group__completed">
            <mat-icon>done</mat-icon>
          </div>
        }

        <div class="content-group__count">
          <span class="title">{{'COMMON.lessons' | translate }}</span>
          <span class="value"> {{ group.lessonsCount + group.quizzesCount }} </span>
        </div>
      </div>
    </div>

  </mat-expansion-panel-header>

  @if (initialized) {
    <div class="content-group__items-wrapper row mb-5">
      @if (items.length) {
        @for (item of items; track item) {
          <div
            class="col-12 py-2 align-self-stretch content-group__item"
            [ngClass]="{ 'col-sm-6 col-lg-4': layout === layouts.GRID, 'layout-row': layout === layouts.ROW }"
            >
            <ng-container *ngTemplateOutlet="template; context: { item: item }"></ng-container>
          </div>
        }
      } @else {
        <div class="col-12">
          <h3 class="content-group__empty">{{'COMMON.ther_are_no' | translate}} {{label}} {{'COMMON.yet' | translate}}.</h3>
        </div>
      }
    </div>
  }
  @if (isLoading) {
    <div class="d-flex align-items-center justify-content-center m-4">
      <mat-spinner color="primary" [diameter]="40"></mat-spinner>
    </div>
  }
</mat-expansion-panel>

